import { AnyArticleDetails, isAnnualArticle, isRentalArticle, isSaleArticle, isSeasonalArticle } from "@shared/graphql";
import { useIntl } from "react-intl";
import SpriteSvg from "../common/svg";

import { article } from "../../i18n/sharable-defs";

import "./equipment-resume.scss";

type Props = {
  data: AnyArticleDetails
}

const EquipmentResume = ({data}:Props) => {
    const intl = useIntl();

  return(
    <div className="equipment-resume">
      {(isRentalArticle(data) || isSeasonalArticle(data)) && <>
          {data.features.maxGuests && <span>
            <SpriteSvg id="person" className="person-svg"/>
            {intl.formatMessage(article.maxGuest,{count: data.features.maxGuests})}
          </span>}
          {data.features.bedrooms && <span>
            <SpriteSvg id="bedroom"/>
            {intl.formatMessage(article.bedrooms_plural,{count: data.features.bedrooms})}
          </span>}
          {data.features.bathrooms && <span>
            <SpriteSvg id="bathroom"/>
            <span>{intl.formatMessage(article.bathrooms_plural,{count: data.features.bathrooms})}</span>
          </span>}
      </>}

      {(isAnnualArticle(data) || isSaleArticle(data)) && <>
          {data.features.bedrooms && <span>
            <SpriteSvg id="bedroom"/>
            {intl.formatMessage(article.bedrooms_plural,{count: data.features.bedrooms})}
          </span>}
          {data.features.bathrooms && <span>
            <SpriteSvg id="bathroom"/>
            {intl.formatMessage(article.bathrooms_plural,{count: data.features.bathrooms})}
          </span>}
      </>}
    </div>
  );
}

export default EquipmentResume;
